export function fromJson<T>(value: string | null, fallbackValue: T): T {
  try {
    return value !== null ? JSON.parse(value) : fallbackValue;
  } catch (e) {
    return fallbackValue;
  }
}
